import { render, staticRenderFns } from "./Nuki.vue?vue&type=template&id=1ce70c62&scoped=true&"
import script from "./Nuki.vue?vue&type=script&lang=js&"
export * from "./Nuki.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=1ce70c62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce70c62",
  null
  
)

export default component.exports